export default __webpack_public_path__ + "61f8009103bbb92ebc0be99da84b4b60.svg";